var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    paddingLeft: (_vm.plr ? _vm.plr : 10) + 'px',
    paddingRight: (_vm.plr ? _vm.plr : 10) + 'px',
  }),attrs:{"id":"sList"},on:{"click":function($event){return _vm.$emit('on-click')}}},[_c('p',[_c('b',[_vm._t("title")],2),_vm._v(" "),_c('span',[_vm._t("day")],2)]),_vm._v(" "),_c('p',[_vm._t("des")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53c8df3a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/src/components/lyList.vue
// module id = null
// module chunks = 